import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import ToolButton from '../../../common/ToolButton';
import BackButton from '../../../common/BackButton';

const StationTools = ({
  history
}) => {
  return (
    <Card>
      <CardBody>
        <ToolButton
          color={"primary"}
          handleClick={() => history.push("/station")}
          icon={"plus"}
          text={"Dodaj Punkt"}
        />
        <BackButton />
      </CardBody>
    </Card>
  )
}

export default withRouter(StationTools);
